import { Component, OnInit } from "@angular/core";
import { UsuarioService } from "../../../modules/seguranca/usuario/usuario.service";
import { Router, ActivatedRoute } from "@angular/router";
import { SharedService } from "../../../common/shared.service";
import { CurrentUser } from "../../../modules/seguranca/current-user.model";

@Component({
  selector: "app-external-login",
  templateUrl: "./external-login.component.html",
  styleUrls: ["./external-login.component.css"],
})
export class ExternalLoginComponent implements OnInit {
  menssage: string = "Aguarde";

  constructor(
    private service: UsuarioService,
    private shared: SharedService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    let user: string = this.route.snapshot.params.user;
    let token: string = this.route.snapshot.params.token;
    this.service.loginExternal({ cpf: user, hash: token }).subscribe(
      (userAuthentication: CurrentUser) => {
        this.shared.logando(userAuthentication);
        this.service.checarCpf(user).subscribe((rs) => {
          this.shared.adm = rs;
          this.service.logar();
          this.router.navigate(["/"]);
        });
      },
      (err) => {
        this.menssage = "Usuário inválido.";
      }
    );
  }
}
